/** 
 * This script fades the left and right sides of the tables shown on the PDP.
*/

function initTableFade(wrapperId) {
  const wrapper = document.getElementById(wrapperId);
  if (!wrapper) return;

  const outer = wrapper.parentElement;

  function checkFade() {
    const scrollLeft = wrapper.scrollLeft;
    const scrollRight = wrapper.scrollWidth - wrapper.scrollLeft - wrapper.clientWidth;

    outer.classList.toggle("fade-left", scrollLeft > 0);
    outer.classList.toggle("fade-right", scrollRight > 1);
  }

  wrapper.addEventListener("scroll", checkFade);

  const ro = new ResizeObserver(checkFade);
  ro.observe(wrapper);

  requestAnimationFrame(checkFade);
}

initTableFade("table-wrapper");
initTableFade("content-table-wrapper");